import type { TFacilityRef } from './facility';

export enum ERoleIdentifier {
  ADMIN = 'ADMIN',
  ADMINISTRATIVE_STAFF = 'ADMINISTRATIVE_STAFF',
  ROTATING_STAFF = 'ROTATING_STAFF',
  READ_ONLY = 'READ_ONLY',
}

type TUserRole = Readonly<{
  id: string
  identifier: ERoleIdentifier
}>;

export enum EUserFacilityRelationType {
  ADMINISTRATE = 'default',
  COORDINATE = 'coordinate',
  READ = 'readonly',
}

// TODO: Combine TUserFacilityRelation & TUserPlanningGroupRelation when coordinate is removed
export type TUserFacilityRelation = Readonly<{
  facility_id: TFacilityRef | string
  type: EUserFacilityRelationType
}>;

type TUserPlanningGroupRelation = Readonly<{
  planning_group_id: string
  type: 'default' | 'readonly'
}>;

type TFavoritePlanningGroupRelation = Readonly<{
  planning_group_id: { id: string; name?: string }
}>;

// ToDo: Properly define it once we've moved to TypeScript
type TDatabaseUser = Partial<{
  id: string
  gender: string
  title: string
  first_name: string
  last_name: string
  email: string
  password: boolean
  tfa_secret: string
  provider: string
  role: TUserRole
  facilities: ReadonlyArray<TUserFacilityRelation>
  main_facility: TFacilityRef & { premium_features?: string[]; use_full_staff_capacities?: boolean }
  main_facility_admin: boolean
  planning_groups: ReadonlyArray<TUserPlanningGroupRelation>
  favorite_planning_groups: ReadonlyArray<TFavoritePlanningGroupRelation>
  time_periods: ReadonlyArray<Pick<TTimePeriod, 'percentage' | 'type' | 'start' | 'end'>>
}>;

export type TStoreUser = TDatabaseUser;
export type TProvider = TDatabaseUser['provider'];

export type TUserWithFacilities = Partial<Pick<TStoreUser, 'facilities'>>;

export type TFacilitiesByType = Readonly<
  Record<EUserFacilityRelationType, TUserFacilityRelation[]>
>;

export type TSortableUser = {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
};

export type TUserNameSortOptions = {
  primary: 'first' | 'last';
  order?: 'asc' | 'desc';
};

export enum EUserNameSortOrder {
  FNAME_ASC = 'FNAME_ASC',
  FNAME_DESC = 'FNAME_DESC',
  LNAME_ASC = 'LNAME_ASC',
  LNAME_DESC = 'LNAME_DESC',
}

export type TExternalDummyUserId = null;

export type TExternalDummyUser = Readonly<{
  id: TExternalDummyUserId;
  first_name: string;
  last_name: string;
}>;
